// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c38ca2e1020477124b8b57c1a51f4af5cd826372.js";
};